require('../stylesheets/public_hotsites.scss');

require('../pages/public_hotsites/matches.js');
require('../pages/public_hotsites/scores_avg_chart.js');
require('../pages/public_hotsites/competitor_charts.js');
require('../pages/public_hotsites/competitor_selector.js');
require('../pages/public_hotsites/live_scorings.js');
require('../pages/public_hotsites/profiles.js');
require('../pages/public_hotsites/rosters.js');
require('../pages/public_hotsites/mobile_top_navigation.js');
require('../pages/public_hotsites/mobile_sidebar.js');
require('../pages/public_hotsites/loader.js');
require('../pages/public_hotsites/round_scores.js');
require('../pages/public_hotsites/skins.js');
require('../pages/public_hotsites/standings.js');
require('../pages/public_hotsites/handicaps.js');